import Swiper from 'swiper';
// import 'swiper/swiper-bundle.css';

import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { ScrollItem__Default } from './ScrollItem__Default';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Basics } from '../_app/cuchillo/core/Basics';

export class ScrollItem__SliderDefault extends ScrollItem__Default {
    _swiper;
    _prev;
    _next;

    _calls = {
        prevSlide: () => this.prevSlide(),
        nextSlide: () => this.nextSlide(),
    }

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._prev = GetBy.selector('[scroll-slider-prev]', __link)[0];
        this._next = GetBy.selector('[scroll-slider-next]', __link)[0];

        this._swiper = new Swiper(GetBy.class('swiper-container', __link)[0], {
            loop: true,
            pagination: false,
            slidesPerView: 1, // Ajusta según lo que necesites
            spaceBetween: 0, // Espacio entre las diapositivas
            autoplay: false,
            simulateTouch: false
        });

        this._prev.addEventListener(Basics.clickEvent, this._calls.prevSlide);
        this._next.addEventListener(Basics.clickEvent, this._calls.nextSlide);
    }

    prevSlide() {
        if (this._swiper) this._swiper.slidePrev();
    }

    nextSlide() {
        if (this._swiper) this._swiper.slideNext();
    }

    resize(w, h) {
        super.resize(w, h);
        if (this._swiper) this._swiper.update(); // Actualizar el swiper en caso de cambio de tamaño
    }

    loop() {
        // if (this._swiper) this._swiper.update(); // Actualizar el swiper en cada loop
    }

    dispose() {
        this._prev.removeEventListener(Basics.clickEvent, this._calls.prevSlide);
        this._next.removeEventListener(Basics.clickEvent, this._calls.nextSlide);

        if (this._swiper) this._swiper.destroy(true, true); // Destruir instancia de Swiper
        super.dispose();
    }
}

class ScrollItem__SliderImages__Item extends VScroll_Item {
    hasHiddenEnabled = false;
    content;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        // this.content = new SplitText(GetBy.selector('.overlay a', __link), {
        //     type: 'lines',
        //     tag: 'span'
        // }).lines;
        // if (this.content.length > 0) gsap.set(this.content, { y: '100%' });

        this.onShow = () => {
            // for (let i = 0; i < this.content.length; i++) {
            //     const item = this.content[i];
            //     gsap.to(item, {
            //         y: 0,
            //         duration: .8,
            //         delay: .3 + 0.04 * i,
            //         ease: Ease.EASE_CUCHILLO_IN_OUT
            //     });
            // }
        };
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================
    update() {
        if (this.progress > .5) {
            const p = Math.max(0, Maths.normalize(1, .5, this.progress));
            this._x = this._x + ((Metrics.WIDTH * .5) * p);
        }

        super.update();
    }

    //   mouseOver () { }
    //   mouseDown () { }
    //   mouseUp () { }

    //   show () {
    //     super.show();
    //   }

    //   hide () {
    //     super.hide();
    //   }
}

Scroll._registerClass('SliderDefault', ScrollItem__SliderDefault);
